module.exports = __webpack_public_path__ + "img/icon_inverse.0ac1e40d.png";